import type { PatientDetails } from 'src/app/types';

export const getPrimaryPatientFromList = (patients: PatientDetails[]): PatientDetails | undefined => {
  return patients.find(patient => patient.isPrimary);
};
